(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nt-cart-drawer"] && !Shopify.designMode) return;
  try {
    const sacola = document.getElementById('nt-sacola');
  if (sacola) {
    // Voltou de /cart/add com ?sacola=1: reabre a gaveta onde ela estava.
    if (new URLSearchParams(location.search).get('sacola') === '1') {
      sacola.showModal();
      const limpo = new URL(location.href);
      limpo.searchParams.delete('sacola');
      history.replaceState(null, '', limpo);
    }
    // Remover um item. Recarrega com ?sacola=1 em vez de redesenhar a gaveta:
    // o total, os adicionais sugeridos e a trava de "so adicionais" sao todos
    // Liquid, e refaze-los no navegador seria manter uma segunda versao da
    // mesma conta. A reabertura ja existia para a volta do /cart/add.
    document.addEventListener('click', async (evento) => {
      const x = evento.target.closest('[data-nt-remover]');
      if (!x) return;
      x.disabled = true;
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: Number(x.dataset.ntRemover), quantity: 0 }),
        });
        const volta = new URL(location.href);
        volta.searchParams.set('sacola', '1');
        location.href = volta.toString();
      } catch (e) {
        x.disabled = false;
      }
    });

    document.addEventListener('click', (evento) => {
      const gatilho = evento.target.closest('[data-nt-sacola-abrir]');
      if (gatilho) {
        evento.preventDefault();
        sacola.showModal();
        return;
      }
      if (evento.target.closest('[data-nt-sacola-fechar]')) {
        sacola.close();
        return;
      }
      // Clique no backdrop tem a propria dialog como alvo: o conteudo fica
      // todo dentro de .nt-sacola__caixa, entao clique interno nunca cai aqui.
      if (evento.target === sacola) sacola.close();
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nt-frete"] && !Shopify.designMode) return;
  try {
    // <nt-frete>: cota o frete por cep.
  //
  // este bloco nao passa pelo liquid: o que vem da loja chega por data-atributo.
  (function () {
    'use strict';
    if (customElements.get('nt-frete')) return;

    // cep -> uf por faixa dos correios; as descontinuidades (df/go, am/rr, mt/ro) sao reais
    var FAIXAS = [
      [1000, 19999, 'SP'], [20000, 28999, 'RJ'], [29000, 29999, 'ES'],
      [30000, 39999, 'MG'], [40000, 48999, 'BA'], [49000, 49999, 'SE'],
      [50000, 56999, 'PE'], [57000, 57999, 'AL'], [58000, 58999, 'PB'],
      [59000, 59999, 'RN'], [60000, 63999, 'CE'], [64000, 64999, 'PI'],
      [65000, 65999, 'MA'], [66000, 68899, 'PA'], [68900, 68999, 'AP'],
      [69000, 69299, 'AM'], [69300, 69399, 'RR'], [69400, 69899, 'AM'],
      [69900, 69999, 'AC'], [70000, 72799, 'DF'], [72800, 72999, 'GO'],
      [73000, 73699, 'DF'], [73700, 76799, 'GO'], [76800, 76999, 'RO'],
      [77000, 77999, 'TO'], [78000, 78899, 'MT'], [78900, 78999, 'RO'],
      [79000, 79999, 'MS'], [80000, 87999, 'PR'], [88000, 89999, 'SC'],
      [90000, 99999, 'RS']
    ];

    function ufDoCep(cep) {
      var d = String(cep).replace(/\D/g, '');
      if (d.length !== 8) return null;
      var p = parseInt(d.slice(0, 5), 10);
      for (var i = 0; i < FAIXAS.length; i++) {
        if (p >= FAIXAS[i][0] && p <= FAIXAS[i][1]) return FAIXAS[i][2];
      }
      return null;
    }
    window.ntUfDoCep = ufDoCep;

    function espera(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

    // sacola vazia pede outra frase
    function Vazia() {}
    Vazia.prototype = Object.create(Error.prototype);

    // nada a cotar aqui: frete e prazo saem no checkout
    function NoCheckout() {}
    NoCheckout.prototype = Object.create(Error.prototype);

    /* ---- a sacola, pela ajax api ---------------------------------- */
    async function pelaSacola(cep, uf) {
      var sacola = await (await fetch('/cart.js')).json();
      if (!sacola.item_count) throw new Vazia();
      // so itens sem frete no cadastro: a ajax api recusa a cotacao
      if (sacola.requires_shipping === false) throw new NoCheckout();
      return cotarAjax(cep, uf);
    }

    async function cotarAjax(cep, uf) {
      var busca = new URLSearchParams();
      busca.set('shipping_address[zip]', cep);
      busca.set('shipping_address[country]', 'Brazil');
      busca.set('shipping_address[province]', uf);

      await fetch('/cart/prepare_shipping_rates.json?' + busca, { method: 'POST' });

      // o async responde 202 enquanto a transportadora nao responde; teto de 20 s
      for (var i = 0; i < 27; i++) {
        await espera(750);
        var r = await fetch('/cart/async_shipping_rates.json?' + busca);
        if (r.status === 200) {
          return ((await r.json()).shipping_rates || []).map(function (t) {
            return {
              nome: t.presentment_name || t.name,
              preco: parseFloat(t.price),
              dias: t.delivery_days && t.delivery_days.length
                ? Math.max.apply(null, t.delivery_days) : null
            };
          });
        }
        if (r.status !== 202) throw new Error('HTTP ' + r.status);
      }
      throw new Error('demorou demais');
    }

    /* ---- um produto, pela storefront api --------------------------- */
    var CRIAR = 'mutation($l:[CartLineInput!]!,$a:[CartSelectableAddressInput!]!){' +
      'cartCreate(input:{lines:$l,buyerIdentity:{countryCode:BR},delivery:{addresses:$a}}){' +
      'cart{id lines(first:5){nodes{quantity merchandise{... on ProductVariant{requiresShipping}}}}} ' +
      'userErrors{message}}}';
    // a api recusa withCarrierRates sem o @defer
    var COTAR = 'query($id:ID!){cart(id:$id){ ... @defer(label:"f"){' +
      'deliveryGroups(first:5,withCarrierRates:true){nodes{deliveryOptions{' +
      'title estimatedCost{amount}}}}}}}';

    async function doProduto(cfg, variante, cep, uf) {
      // a storefront da propria loja ve o catalogo da loja virtual, o mesmo do checkout. o token do
      // ajuste e de outro canal (o novalite nao esta nele) e so entra se a loja nao responder.
      // sem o .json: nesse caminho o pixel da shopify conta cada consulta como produto adicionado
      var portas = [{ url: '/api/' + cfg.versao + '/graphql' }];
      if (cfg.dominio && cfg.token) {
        portas.push({ url: 'https://' + cfg.dominio + '/api/' + cfg.versao + '/graphql', token: cfg.token });
      }

      function chamar(porta, query, variables, accept) {
        var cabecalho = { 'Content-Type': 'application/json', Accept: accept || 'application/json' };
        if (porta.token) cabecalho['X-Shopify-Storefront-Access-Token'] = porta.token;
        // sem cookies: a resposta traz cookies de sessao novos, que trocariam a sacola de quem compra
        return fetch(porta.url, {
          method: 'POST',
          headers: cabecalho,
          credentials: 'omit',
          body: JSON.stringify({ query: query, variables: variables })
        }).then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r;
        });
      }

      // cep, estado e pais bastam para a cotacao: rua e cidade inventadas seriam dado falso
      var pedido = {
        l: [{ merchandiseId: 'gid://shopify/ProductVariant/' + variante, quantity: 1 }],
        a: [{ selected: true, address: { deliveryAddress: { provinceCode: uf, countryCode: 'BR', zip: cep } } }]
      };
      var porta = null;
      var carrinho = null;
      for (var i = 0; i < portas.length && !carrinho; i++) {
        var criada;
        try {
          criada = await (await chamar(portas[i], CRIAR, pedido)).json();
        } catch (e) {
          if (i + 1 === portas.length) throw e;
          continue;
        }
        // limite da shopify: o token e de outro canal e nao ve o novalite, entao cair nele so
        // trocaria a mensagem neutra por um erro
        var limitado = (criada.errors || []).some(function (erro) {
          return erro.extensions && erro.extensions.code === 'THROTTLED';
        });
        if (limitado) throw new NoCheckout();
        carrinho = criada.data && criada.data.cartCreate && criada.data.cartCreate.cart;
        porta = portas[i];
      }
      if (!carrinho) throw new Error('carrinho nao criado');

      // esgotada entra com quantidade 0, e produto sem frete no cadastro nao gera entrega:
      // nos dois casos nao ha o que cotar, e esperar a transportadora seria tempo perdido
      var linhas = (carrinho.lines && carrinho.lines.nodes) || [];
      var cotavel = linhas.some(function (l) {
        return l.quantity > 0 && l.merchandise && l.merchandise.requiresShipping;
      });
      if (!cotavel) throw new NoCheckout();

      // o @defer entrega o que ja esta pronto: com o carrinho recem-criado a transportadora pode
      // nao ter respondido e o grupo volta vazio. insiste dez vezes; a shopify tambem pode recusar
      // por limite (THROTTLED), e ai insistir so piora
      var opcoes = [];
      var limite = false;
      for (var volta = 0; volta < 10 && !opcoes.length && !limite; volta++) {
        if (volta) await espera(800);
        var texto = await (await chamar(porta, COTAR, { id: carrinho.id }, 'multipart/mixed')).text();
        texto.split('\n').forEach(function (linha) {
          linha = linha.trim();
          if (linha.charAt(0) !== '{') return;
          var j;
          try { j = JSON.parse(linha); } catch (e) { return; }
          var partes = j.incremental || [{ data: j.data && j.data.cart, errors: j.errors }];
          partes.forEach(function (p) {
            (p.errors || []).forEach(function (erro) {
              if (erro.extensions && erro.extensions.code === 'THROTTLED') limite = true;
            });
            var g = p.data && p.data.deliveryGroups;
            if (g && g.nodes) g.nodes.forEach(function (n) {
              opcoes = opcoes.concat(n.deliveryOptions || []);
            });
          });
        });
      }
      if (!opcoes.length) throw new NoCheckout();

      // a storefront nao tem campo de prazo: so preco
      return opcoes.map(function (o) {
        return { nome: o.title, preco: parseFloat(o.estimatedCost.amount), dias: null };
      });
    }

    customElements.define(
      'nt-frete',
      class extends HTMLElement {
        connectedCallback() {
          this.campo = this.querySelector('[data-nt-frete-cep]');
          this.bt = this.querySelector('[data-nt-frete-bt]');
          this.estado = this.querySelector('[data-nt-frete-estado]');
          this.lista = this.querySelector('[data-nt-frete-lista]');
          this.nota = this.querySelector('[data-nt-frete-nota]');
          if (!this.campo || !this.bt) return;
          this.vez = 0;

          this.moeda = new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: this.getAttribute('data-moeda') || 'BRL'
          });

          this.noProduto = this.getAttribute('data-origem') === 'produto';
          if (this.noProduto) {
            this.cfg = {
              dominio: this.getAttribute('data-dominio'),
              token: this.getAttribute('data-token'),
              versao: this.getAttribute('data-versao') || '2026-07'
            };
            // o montador guarda o kit no select; trocou de kit, a cotacao na tela era de outro
            this.seletor = document.querySelector('[data-nt-id]');
            if (this.seletor) this.seletor.addEventListener('change', this.limpar.bind(this));
          }

          this.campo.addEventListener('input', this.mascara.bind(this));
          this.campo.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') { e.preventDefault(); this.calcular(); }
          }.bind(this));
          this.bt.addEventListener('click', this.calcular.bind(this));
        }

        mascara() {
          var d = this.campo.value.replace(/\D/g, '').slice(0, 8);
          this.campo.value = d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d;
        }

        esconderLista() {
          this.lista.hidden = true;
          if (this.nota) this.nota.hidden = true;
        }

        limpar() {
          // a resposta que ainda estiver a caminho e de outro kit e nao entra
          this.vez++;
          this.esconderLista();
          this.aviso('');
        }

        aviso(texto, erro) {
          this.estado.textContent = texto;
          this.estado.classList.toggle('nt-frete__estado--erro', !!erro);
          this.estado.hidden = !texto;
        }

        async calcular() {
          var uf = ufDoCep(this.campo.value);
          this.esconderLista();
          if (!uf) {
            this.aviso('CEP incompleto ou inexistente. Confira os 8 dígitos.', true);
            return;
          }
          var cep = this.campo.value;
          var vez = ++this.vez;

          this.bt.disabled = true;
          this.aviso('Consultando a transportadora…');

          try {
            var taxas;
            if (this.noProduto) {
              var variante = this.seletor && this.seletor.value;
              if (!variante) throw new Error('sem variante');
              taxas = await doProduto(this.cfg, variante, cep, uf);
            } else {
              taxas = await pelaSacola(cep, uf);
            }
            if (vez === this.vez) this.mostrar(taxas, uf);
          } catch (e) {
            if (vez !== this.vez) return;
            if (e instanceof NoCheckout) {
              this.aviso('Frete e prazo calculados no checkout.');
            } else {
              this.aviso(
                e instanceof Vazia
                  ? 'Coloque um kit na sacola para calcular o frete.'
                  : 'Não deu para consultar o frete agora. Tente de novo em instantes.',
                true
              );
            }
          } finally {
            this.bt.disabled = false;
          }
        }

        mostrar(taxas, uf) {
          if (!taxas.length) {
            this.aviso('Não há entrega para esse CEP (' + uf + ').', true);
            return;
          }
          this.aviso('Entrega para ' + this.campo.value + ' (' + uf + '):');

          // da mais barata para a mais cara, e todas
          taxas = taxas.slice().sort(function (a, b) { return a.preco - b.preco; });

          // montado em nos: o nome da transportadora vem de um app de terceiro
          this.lista.textContent = '';
          taxas.forEach(function (t) {
            var li = document.createElement('li');
            li.className = 'nt-frete__item';

            var nome = document.createElement('span');
            nome.className = 'nt-frete__nome';
            nome.textContent = t.nome;
            if (t.dias) {
              var prazo = document.createElement('span');
              prazo.className = 'nt-frete__prazo';
              prazo.textContent = 'em até ' + t.dias + (t.dias === 1 ? ' dia útil' : ' dias úteis');
              nome.appendChild(prazo);
            }

            var preco = document.createElement('span');
            preco.className = 'nt-frete__preco';
            preco.textContent = this.moeda.format(t.preco);

            li.appendChild(nome);
            li.appendChild(preco);
            this.lista.appendChild(li);
          }, this);

          this.lista.hidden = false;
          // sem prazo na cotacao (pagina do produto), a frase diz onde ele aparece
          if (this.nota) this.nota.hidden = taxas.every(function (t) { return t.dias; });
        }
      }
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nt-reserva"] && !Shopify.designMode) return;
  try {
    // <nt-reserva> — o modal de reserva e a confirmacao.
  //
  // Este bloco NAO passa pelo Liquid: chave dupla aqui dentro nao vira valor
  // nenhum, e escrever uma mesmo em comentario faz o Theme Check recusar o
  // arquivo inteiro. O que vem da loja chega por data-atributo no markup.
  (function () {
    'use strict';
    if (customElements.get('nt-reserva')) return;

    var ESPERA_MS = 60000;
    var CHAVE = 'nt-reserva-espera';
    var EMAIL = /^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/;

    function guardado() {
      try { return Number(localStorage.getItem(CHAVE) || 0); } catch (e) { return 0; }
    }
    function guardar(ate) {
      try { localStorage.setItem(CHAVE, String(ate)); } catch (e) { /* modo anonimo */ }
    }

    customElements.define(
      'nt-reserva',
      class extends HTMLElement {
        connectedCallback() {
          this.modal = this.querySelector('[data-nt-res-modal]');
          this.ok = this.querySelector('[data-nt-res-ok]');
          this.form = this.querySelector('[data-nt-res-form]');
          if (!this.modal || !this.form) return;

          this.url = this.getAttribute('data-url');
          this.nome = this.querySelector('[data-nt-res-nome]');
          this.email = this.querySelector('[data-nt-res-email]');
          this.whats = this.querySelector('[data-nt-res-whats]');
          this.isca = this.querySelector('[data-nt-res-isca]');
          this.enviar = this.querySelector('[data-nt-res-enviar]');
          this.aviso = this.querySelector('[data-nt-res-aviso]');
          this.alvoProduto = this.querySelector('[data-nt-res-produto]');
          this.okTitulo = this.querySelector('[data-nt-res-ok-titulo]');

          // Delegado no documento: os botoes de reservar nascem em secoes
          // diferentes, e alguns so aparecem quando o produto esgota. Escutar
          // aqui dispensa cada secao de saber que este modal existe.
          document.addEventListener('click', this.talvezAbrir.bind(this));

          // O CLIQUE QUE CHEGOU ANTES DAQUI. Este arquivo e um bundle com
          // `defer`: entre a pagina ficar clicavel e ele rodar existe uma
          // janela de centenas de milissegundos numa rede boa, e de segundos
          // num celular ruim. Nela o gatilho ainda e um link, e clicar levava
          // a pagina de venda de um produto esgotado — o oposto do que o botao
          // promete. O <script> de parse do snippet segura esse clique e
          // guarda o gatilho aqui.
          if (window.__ntReservaPendente) {
            var pendente = window.__ntReservaPendente;
            window.__ntReservaPendente = null;
            this.abrirPara(pendente);
          }

          this.querySelector('[data-nt-res-fechar]').addEventListener('click', function () {
            this.modal.close();
          }.bind(this));
          this.querySelector('[data-nt-res-ok-fechar]').addEventListener('click', function () {
            this.ok.close();
          }.bind(this));

          // Clique no fundo escurecido tem a propria <dialog> como alvo: o
          // conteudo todo mora em .nt-res__caixa, entao clique interno nunca
          // cai aqui.
          [this.modal, this.ok].forEach(function (d) {
            d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
          });

          this.whats.addEventListener('input', this.mascara.bind(this));
          this.form.addEventListener('submit', this.enviarForm.bind(this));
        }

        talvezAbrir(evento) {
          var g = evento.target.closest('[data-nt-reserva], a[href="#reserva"]');
          if (!g) return;
          evento.preventDefault();
          this.abrirPara(g);
        }

        abrirPara(g) {
          this.produto = {
            handle: g.getAttribute('data-nt-produto') || '',
            titulo: g.getAttribute('data-nt-titulo') || '',
            variante: g.getAttribute('data-nt-variante') || '',
            configuracao: null
          };
          // A CONFIGURACAO vem pronta do gatilho, em JSON. Quem monta e quem
          // sabe: o configurador de kit conhece o nome de cada opcao e o valor
          // marcado naquele instante. Aqui so se le — e se o JSON estiver
          // torto, segue sem ele, porque configuracao e detalhe do aviso e nao
          // condicao da reserva.
          var cfg = g.getAttribute('data-nt-config');
          if (cfg) {
            try { this.produto.configuracao = JSON.parse(cfg); } catch (e) { /* segue sem */ }
          }
          // Sem produto no gatilho, vale o da pagina — um "Reservar" solto
          // numa pagina de produto quer dizer aquele produto. Sem os dois, o
          // modal nao abre: reserva sem produto nao e reserva de nada.
          this.produto.handle = this.produto.handle || this.getAttribute('data-nt-produto') || '';
          this.produto.titulo = this.produto.titulo || this.getAttribute('data-nt-titulo') || '';
          if (!this.produto.handle || !this.produto.titulo) return;

          this.alvoProduto.textContent = this.produto.titulo;
          this.dizer('');
          this.modal.showModal();
        }

        // Formata enquanto digita, mas o que vale e o digito: o servidor
        // guarda so numero, senao "(11) 9..." e "11 9..." contariam como duas
        // pessoas e o limite por contato nao valeria nada.
        mascara() {
          var d = this.whats.value.replace(/\D/g, '').slice(0, 11);
          var saida = d;
          if (d.length > 2) saida = '(' + d.slice(0, 2) + ') ' + d.slice(2);
          if (d.length > 7) {
            var corte = d.length > 10 ? 7 : 6;
            saida = '(' + d.slice(0, 2) + ') ' + d.slice(2, corte) + '-' + d.slice(corte);
          }
          this.whats.value = saida;
        }

        campoErro(seletor, texto) {
          var el = this.querySelector(seletor);
          el.textContent = texto || '';
          el.hidden = !texto;
        }

        dizer(texto, erro) {
          this.aviso.textContent = texto;
          this.aviso.classList.toggle('nt-res__aviso--erro', !!erro);
          this.aviso.hidden = !texto;
        }

        async enviarForm(evento) {
          evento.preventDefault();

          var falta = Math.ceil((guardado() - Date.now()) / 1000);
          if (falta > 0) {
            this.dizer('Aguarde ' + falta + 's antes de enviar outra reserva.', true);
            return;
          }

          var email = this.email.value.trim();
          var whats = this.whats.value.replace(/\D/g, '');
          this.campoErro('[data-nt-res-erro-email]', EMAIL.test(email) ? '' : 'E-mail inválido');
          this.campoErro('[data-nt-res-erro-whats]', whats.length >= 10 && whats.length <= 15 ? '' : 'WhatsApp inválido');
          if (!EMAIL.test(email) || whats.length < 10 || whats.length > 15) return;

          this.enviar.disabled = true;
          this.dizer('Enviando…');

          try {
            // O QUE JA ESTA NA SACOLA entra na configuracao. Quem reserva um
            // produto costuma estar levando outro junto, e o que ela escolheu
            // ali — case personalizada, garantia estendida — e parte do pedido
            // que quem le no Discord precisa ver. Sem lista de handles
            // cravada: vale qualquer item, menos o proprio produto reservado,
            // que ja e o titulo da mensagem.
            var config = Object.assign({}, this.produto.configuracao || {});
            try {
              var sacola = await (await fetch('/cart.js')).json();
              (sacola.items || []).forEach(function (item) {
                if (item.handle === this.produto.handle) return;
                config['Na sacola: ' + item.product_title] =
                  item.quantity + (item.variant_title ? ' — ' + item.variant_title : '');
              }, this);
            } catch (e) { /* sacola indisponivel nao impede a reserva */ }

            var r = await fetch(this.url, {
              method: 'POST',
              headers: { 'content-type': 'application/json' },
              body: JSON.stringify({
                nome: this.nome.value.trim(),
                email: email,
                whatsapp: whats,
                sobrenome: this.isca.value,
                produto_handle: this.produto.handle,
                produto_titulo: this.produto.titulo,
                variante: this.produto.variante,
                configuracao: Object.keys(config).length ? config : null
              })
            });
            var corpo = await r.json().catch(function () { return {}; });
            if (!r.ok) {
              // A funcao devolve frase pronta em portugues nos limites; para o
              // resto, uma generica — mensagem de erro de servidor descreve
              // tabela e coluna, e nao e assunto de quem esta comprando.
              this.dizer(r.status === 429 && corpo.erro
                ? corpo.erro
                : 'Não deu para registrar agora. Tente de novo em instantes.', true);
              return;
            }

            guardar(Date.now() + ESPERA_MS);
            this.form.reset();
            this.dizer('');
            this.campoErro('[data-nt-res-erro-email]', '');
            this.campoErro('[data-nt-res-erro-whats]', '');
            this.modal.close();
            this.okTitulo.textContent = 'Seu ' + this.produto.titulo + ' está reservado';
            this.ok.showModal();
          } catch (e) {
            this.dizer('Não deu para registrar agora. Tente de novo em instantes.', true);
          } finally {
            this.enviar.disabled = false;
          }
        }
      }
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
